import React, { useContext, useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { FirebaseContext } from 'context';
import { Button } from 'components';
import { Container, Title, Card, Label, FormSelect } from '../Shared';

const setFormInitialState = () => ({
  name: '',
  email: '',
  company: '',
  sessionsUserHasAccessTo: []
});

function CreateUser({ customDropdownMenuStyles, sessions }) {
  const { firebase } = useContext(FirebaseContext);
  const [formIncomplete, setFormIncomplete] = useState(true);
  const [creatingUser, setCreatingUser] = useState(false);
  const [formValues, setFormValues] = useState(setFormInitialState());

  useEffect(() => {
    const { name, email } = formValues;
    if (name && email) {
      setFormIncomplete(false);
    } else {
      setFormIncomplete(true);
    }
  }, [formValues]);

  const handleCreateUser = async () => {
    try {
      const { name, email, company } = formValues;
      if (name && email) {
        setCreatingUser(true);
        await firebase.admin.createUser({
          name,
          email: email.toLowerCase().trim(),
          company: company ?? '',
          sessionsUserHasAccessTo: formValues.sessionsUserHasAccessTo.length
            ? formValues.sessionsUserHasAccessTo.map((session) => session.value)
            : []
        });
      }
    } catch (_error) {
      console.error(_error);
    } finally {
      setCreatingUser(false);
      setFormValues(setFormInitialState());
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((currentState) => ({
      ...currentState,
      [name]: value
    }));
  };

  return (
    <Container>
      <Title>Add User</Title>
      <Card>
        <div>
          <Label>Name</Label>
          <input
            type="text"
            name="name"
            onChange={handleInputChange}
            value={formValues.name}
          />
        </div>
        <div>
          <Label>Email</Label>
          <input
            type="email"
            name="email"
            onChange={handleInputChange}
            value={formValues.email}
          />
        </div>
        <div>
          <Label>Company</Label>
          <input
            type="text"
            name="company"
            onChange={handleInputChange}
            value={formValues.company}
          />
        </div>
        <div>
          <Label>Sessions User Has Access To</Label>
          <FormSelect
            value={formValues.sessionsUserHasAccessTo}
            onChange={(selectedSessions) => {
              setFormValues((currentState) => ({
                ...currentState,
                sessionsUserHasAccessTo: selectedSessions
              }));
            }}
            placeholder="Select"
            styles={customDropdownMenuStyles()}
            options={sessions}
            isMulti
          />
        </div>
        <AnimatePresence>
          <Button
            type="button"
            loading={creatingUser}
            style={{
              margin: '0.75rem auto 0'
            }}
            disabled={formIncomplete}
            onClick={handleCreateUser}
            changeColorWhenDisabled={false}>
            Create User
          </Button>
        </AnimatePresence>
      </Card>
    </Container>
  );
}

export default CreateUser;
